import type {EditServiceNoteFormPayload} from "./edit-service-note.schema";

import {editServiceNote} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../../../service-keys";

export function editServiceNoteMutationOptions(id: string, noteId: number) {
  return mutationOptions({
    mutationKey: serviceMutationKeys.editServiceNote,
    mutationFn: (payload: EditServiceNoteFormPayload) => editServiceNote(id, noteId, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: serviceKeys.detail(id)}),
        client.invalidateQueries({queryKey: serviceKeys.lists()}),
      ]);
    },
  });
}
